import(/* webpackMode: "eager" */ "/app/src/app/link-portal/page.tsx");
